var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "help" } }, [
    _c(
      "div",
      { staticClass: "help-tree" },
      _vm._l(_vm.helpTree, function(first) {
        return _c(
          "div",
          { key: first.type_id, staticClass: "first-type" },
          [
            _c(
              "div",
              {
                class: ["first-title", { active: first.isBol }],
                on: {
                  click: function($event) {
                    first.isBol = !first.isBol
                  }
                }
              },
              [
                first.children
                  ? _c("div", [
                      _c("span", [_vm._v(_vm._s(first.type_name))]),
                      _c("i", { staticClass: "el-icon-arrow-down" })
                    ])
                  : _c(
                      "nuxt-link",
                      {
                        class: [
                          "second-title",
                          { active: _vm.helpType == first.type_id }
                        ],
                        staticStyle: { display: "block", color: "#555" },
                        attrs: { to: "/trait/help/" + first.type_id }
                      },
                      [_c("span", [_vm._v(_vm._s(first.type_name))])]
                    )
              ],
              1
            ),
            _vm._l(first.children, function(second) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: first.isBol,
                      expression: "first.isBol"
                    }
                  ],
                  key: second.type_id,
                  staticClass: "second-type"
                },
                [
                  _c(
                    "nuxt-link",
                    {
                      class: [
                        "second-title",
                        { active: _vm.helpType == second.type_id }
                      ],
                      attrs: { to: "/trait/help/" + second.type_id }
                    },
                    [_c("span", [_vm._v(_vm._s(second.type_name))])]
                  )
                ],
                1
              )
            })
          ],
          2
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c2fcf77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c2fcf77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/layouts/helper/Left.vue
// module id = DFPN
// module chunks = 1 4 5 6 7